<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items-per-page="5"
            :items="dataItems"
            class="elevation-1"
            fixed-header
            height="350"
            >

            <template v-slot:header.isSelect="{ }">
                    <v-checkbox :value="isSelectAll" @change="toggleAll()">

                    </v-checkbox> 
            </template>


            <template  v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>รายการอะไหล่</v-toolbar-title>
                    <v-divider
                    class="mx-4"
                    inset
                    vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    
                    <v-btn v-if="selectedItems.length > 0" @click="withdrawItems" small color="primary">รับอะไหล่</v-btn>
                    <v-dialog v-model="dialogDetail" max-width="720px">
                        <v-card>
                            <v-card-title>
                            ข้อมูลการเบิกอะไหล่
                            </v-card-title>
                            <v-card-text>
                                <v-data-table
                                    :headers="headersDetail"
                                    :items-per-page="5"
                                    :items="itemDetails"  
                                    class="elevation-1"
                                    hide-default-footer
                                    >
                                </v-data-table>
                            </v-card-text>
                        
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    text
                                    @click="dialogDetail = false"
                                >
                                    ปิด
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="dialog" max-width="700px">
                        <v-card outlined>
                            <v-card-title ><strong class="mr-2">เบิกอะไหล่  </strong> &nbsp; <h5> (เมื่อกดบันทึกจะทำการ เบิกอะไหล่เข้าระบบทันที)</h5></v-card-title>
                            <v-divider class="ma-2"></v-divider>
                            <div class="pl-5 pr-5">
                                <v-form ref="formDetail" lazy-validation>
                                    <v-row v-if="!isMultiSelect">
                                        <v-col>
                                            <v-select
                                                v-model="selectedReceveNo"
                                                :items=receiveNoList
                                                item-text="receiveNo"
                                                item-value="receivePartsId"
                                                label="เลขที่ใบรับอะไหล่"
                                                outlined
                                                return-object
                                                :rules="[rules.required]"
                                            >
                                            </v-select>
                                        </v-col>
                                        <v-col>
                                            <v-text-field outlined 
                                            placeholder=" " 
                                            label="จำนวนที่เบิก"
                                            :rules="[rules.required, rules.requiredMaxNumber(selectedReceveNo.qty), rules.requiredMaxNumber(item.jobQty)]"
                                            v-model="withdrawQty">
                                        </v-text-field>
                                        </v-col>
                                    </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field outlined 
                                            placeholder=" " 
                                            label="ชื่อช่างที่เบิก"
                                            :rules="[rules.required]"
                                            v-model="withdrawBy">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                </v-form> 
                            </div>
                            <v-card-actions class="text-right">
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="saveDetail">บันทึก</v-btn>
                                <v-btn color="primary" @click="closeDialog"> ยกเลิก</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>

            <template v-slot:item.isSelect="{ item }">
                <v-checkbox
                        v-if="canEdit"
                        :id="item.partsCode"
                        :value="item.isSelect"
                        v-model="item.isSelect"
                        v-ripple="item.partsCode"
                        @change="toggle(item)"
                        :disabled="item.jobQty != item.stockQty || item.stockQty == 0"
                ></v-checkbox>
            </template>

            <template v-slot:item.status="{ item }">
                <v-label
                    v-if="item.jobQty == item.qty"
                    small
                    color="red"
                > เบิกอะไหล่ครบแล้ว</v-label>
                <v-label
                    v-else-if="item.qty < item.jobQty && item.stockQty > 0"
                    small
                    color="red"
                > รอเบิกอะไหล่</v-label>
                <v-label
                    v-else-if="item.jobQty > 0 && item.stockQty == 0"
                    small
                    color="red"
                > รออะไหล่</v-label>
            </template>

            <template v-if="canEdit" v-slot:item.action="{ item }">
                <v-tooltip v-if="item.qty > 0" top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        v-bind="attrs"
                        v-on="on"
                        small
                        style="margin:5px;"
                         @click="showDetail(item)"
                    >
                        mdi-24px  mdi-clipboard-search-outline
                    </v-icon> &nbsp; &nbsp;
                    </template>
                    <span>ดูข้อมูล</span>
                </v-tooltip>&nbsp;
                <!--
                <v-tooltip v-if="item.jobQty == item.qty" top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        v-bind="attrs"
                        v-on="on"
                        small
                    >
                        mdi-24px mdi-cloud-check
                    </v-icon> &nbsp;
                    </template>
                    <span>เบิกแล้ว</span>
                </v-tooltip>
                -->
                <v-tooltip v-if="item.qty < item.jobQty && item.stockQty > 0" top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        v-bind="attrs"
                        v-on="on"
                        small
                         @click="withdrawItem(item)"
                    >
                        mdi-24px mdi-cloud-print
                    </v-icon> &nbsp;
                    </template>
                    <span>เบิกอะไหล่</span>
                </v-tooltip>
                </template>
        </v-data-table>
    </v-container>
</template>

<script>
import {withdrawParts, listJobReceiveParts, listReceiveParts, withdrawPartsByCode, listWithdrawDetail} from '@/api/job/job-api.js'
import rules from '@/assets/js/rules.js'
export default {
    name: 'Tab4',
    computed: {
        dataItems() {
            let tmp = [];
            if (this.newItems != undefined && this.newItems.length > 0) {
                tmp = this.newItems;
            } else {
                tmp = this.items;
            }
            tmp.forEach(o => {
                o.isSelect = false;
            });
            return tmp;
        }
    },
    watch: {
        selectedReceveNo(val) {
            this.withdrawQty = val.qty;
        }
    },
    props: ["items", "canEdit"],
    data: () => ({
        isSelectAll: false,
        isMultiSelect: false,
        dialog: false,
        dialogDetail: false,
        receiveNoList: [],
        selectedItems: [],
        newItems: [],
        rules: rules,
        selectedReceveNo: {receiveNo: '', qty: 0},
        withdrawQty: 0,
        withdrawBy: '',
        receivePartsId: -1,
        editedIndex: -1,
        item: {},
        headers: [
            {value: 'isSelect'},
            {text: 'No.', value: 'no'},
            {text: 'รหัสอะไหล่', value: 'partsCode'},
            {text: 'รายการอะไหล่', value: 'partsName'},
            {text: 'จำนวนที่สั่ง', value: 'jobQty'},
            {text: 'จำนวนที่เบิกแล้ว', value: 'qty'},
            {text: 'จำนวนใน stock', value: 'stockQty'},
            {text: 'สถานะ', value: 'status'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        headersDetail: [
            {text: 'No.', value: 'no'},
            {text: 'เลขที่ใบรับอะไหล่', value: 'receiveNo'},
            {text: 'จำนวนที่เบิกไปแล้ว', value: 'qty'},
            {text: 'วันที่เบิกล่าสุด', value: 'withdrawDatetime'},
            {text: 'ช่างที่เบิกล่าสุด', value: 'withdrawBy'}
        ],
        itemDetails: [

        ]
    }),
    methods: {
        toggleAll() {
            this.isSelectAll = !this.isSelectAll;
            this.dataItems.forEach(item => {
                if (item.jobQty != item.stockQty || item.stockQty == 0) return;
                item.isSelect = this.isSelectAll;
                this.toggle(item);
            });
            
        },
        showDetail(item) {
            this.dialogDetail = true;
            this.item = item;
            this.itemDetails = [];
            listWithdrawDetail(item.jobNo, item.branchCode, item.partsCode).then(rs => {
                this.itemDetails = rs;
            });
        },
        toggle(item) {
            if (this.selectedItems.includes(item)) {
                let index = this.selectedItems.indexOf(item);
                this.selectedItems.splice(index, 1);
            } else {
                this.selectedItems.push(item);
            }
        },
        withdrawItems() {
            this.isMultiSelect = true;
            this.dialog = true;
        },
        withdrawItem(item) {
            this.item = item;
            this.editedIndex = this.items.indexOf(item);
            //this.receivePartsDetailId = item.receivePartsDetailId;
            this.receiveNoList = [];
            this.selectedReceveNo = {};
            listReceiveParts(item.partsCode, item.jobNo, item.branchCode).then(rs => {
                this.receiveNoList = rs
                this.selectedReceveNo = this.receiveNoList[0];
            });
            this.dialog = true;
        },
        saveDetail() {
            if (!this.$refs.formDetail.validate()) {
                return;
            }
            let promises = [];
            if (this.isMultiSelect) {
                this.selectedItems.forEach(o => {
                    promises.push(withdrawPartsByCode(o.jobNo, o.branchCode, o.partsCode, this.withdrawBy));
                });
                
            } else {
                this.receivePartsId = this.receiveNoList.filter(o => o.receiveNo == this.selectedReceveNo.receiveNo)[0].receivePartsId;
                promises.push(withdrawParts(this.item.jobNo, this.item.branchCode, this.item.partsCode, this.withdrawBy, this.withdrawQty, this.receivePartsId));
            }
            Promise.all(promises).then(() => {
                this.newItems = [];
                listJobReceiveParts(this.items[0].jobNo, this.items[0].branchCode).then(rs => {
                    this.newItems = rs;
                });
                this.$emit("edited", true);
                this.closeDialog();
                this.isSelectAll = false;
            });
            
            
        },
        closeDialog() {
            //this.selectedItems = [];
            this.editedIndex = -1;
            this.selectedReceveNo = {};
            this.receiveNoList = [];
            this.withdrawBy = '',
            this.receivePartsId = -1;
            this.dialog = false;
            this.isMultiSelect = false;
        }
    }
}
</script>